import * as React from "react";

import { IconGame } from "../icons/IconGame";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonGame: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonHierarchy.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconGame fixedWidth />
            { }
        </MprcIconButton>
    );
};
